export const certificateConstants = {

  REGISTER_TYPE01_REQUEST: 'CERTIFICATE_REGISTER_TYPE01_REQUEST',
  REGISTER_TYPE01_SUCCESS: 'CERTIFICATE_REGISTER_TYPE01_SUCCESS',
  REGISTER_TYPE01_FAILURE: 'CERTIFICATE_REGISTER_TYPE01_FAILURE',

  REGISTER_TYPE02_REQUEST: 'CERTIFICATE_REGISTER_TYPE02_REQUEST',
  REGISTER_TYPE02_SUCCESS: 'CERTIFICATE_REGISTER_TYPE02_SUCCESS',
  REGISTER_TYPE02_FAILURE: 'CERTIFICATE_REGISTER_TYPE02_FAILURE',

  GETDOCUMENT_REQUEST: 'GETDOCUMENT_REQUEST',
  GETDOCUMENT_SUCCESS: 'GETDOCUMENT_SUCCESS',
  GETDOCUMENT_FAILURE: 'GETDOCUMENT_FAILURE',
}
